export const baseURL = "https://api.vendor.rentalpe.co.in/";
// export const baseURL = 'http://13.201.185.90:6001/'                                            
